import { routes } from "@/routes/utils";
import { useDownloadUserProfile } from "@/services";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const useMyProfile = () => {
  const queryClient = useQueryClient();
  const [currentStep, setCurrentStep] = useState<number>(1);

  const {userData, communityData} = useSelector(
    (state: any) => state.currentData
  );

  const onNextStepClick = () => {
    setCurrentStep(currentStep + 1);
  };

  const onPreviousStepClick = () => {
    setCurrentStep(currentStep - 1);
  };

  const onStepperClick = (curr_step: number) => {
    setCurrentStep(curr_step);
  };

  const onTermsConditionClick = () => {
    window.open(`${routes.termsCondition}`, "_blank");
  };
  
  const {data: profileData, isRefetching: isRefetchingProfile, refetch: refetchProfile} = useDownloadUserProfile({
    communityId: communityData?.communityId as string,
    queryParams: {
      enabled: false
    }
  });
  
  const onDownloadProfileClick = () => {
    // window.open(`${routes.downloadFile}`, "_blank");
    refetchProfile();
  };

  useEffect(() => {
    if (profileData) {
      const blob = new Blob([profileData.data], {
        type: profileData.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Try to get filename from headers, fallback to fileName or default
      const contentDisposition = profileData.headers["content-disposition"];
      let downloadFileName = "my-profile.pdf";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          downloadFileName = match[1];
        }
      }

      link.setAttribute("download", downloadFileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      queryClient.cancelQueries({queryKey: ["user-profile-pdf"]})
    }
  }, [profileData])

  return {
    currentStep,
    setCurrentStep,
    onNextStepClick,
    onStepperClick,
    onPreviousStepClick,
    onTermsConditionClick,
    onDownloadProfileClick,
    userData,
    isRefetchingProfile
  };
};

export default useMyProfile;
